import { type FC, type ReactNode } from "react";
import * as styles from "./styles.css";

type Size = styles.SizeVariants;

type Props = {
  className?: string;
  tag: React.ElementType;
  hasBorder?: boolean;
  hasBackgroundColor?: boolean;
  isBiyo?: boolean;
  icon?: ReactNode;
  children: ReactNode;
  label?: ReactNode;
  description?: ReactNode;
  button?: ReactNode;
} & Size;

export const Heading: FC<Props> = ({
  className = "",
  tag: Tag,
  hasBorder = false,
  hasBackgroundColor = false,
  isBiyo = true,
  size = "xLarge",
  icon,
  children,
  label,
  description,
  button,
}) => (
  <div
    className={`
      ${styles.headingOuter({
        border: createBorderVariant(hasBorder, size, isBiyo),
        background: size === "large" && hasBackgroundColor ? "gray" : "none",
      })}
      ${className}
    `}
  >
    <div
      className={`${styles.headingAndLabel} ${
        size === "large" && hasBackgroundColor ? styles.headingAndLabelWithBackground : ""
      }`}
    >
      <Tag className={styles.heading({ size })}>
        {icon && size !== "xLarge" && <span className={styles.iconOuter({ size })}>{icon}</span>}
        {children}
      </Tag>
      {label && <span className={styles.labelOuter}>{label}</span>}
    </div>
    {description && (
      <p className={styles.descriptionOuter[hasBackgroundColor ? "hasBackgroundColor" : "default"]}>
        {description}
      </p>
    )}
    {button && (
      <p className={styles.buttonOuter[hasBackgroundColor ? "hasBackgroundColor" : "default"]}>
        {button}
      </p>
    )}
  </div>
);

const createBorderVariant = (hasBorder: boolean, size: Props["size"], isBiyo: boolean) => {
  if (!hasBorder) {
    return "none";
  }
  if (size === "large") {
    return isBiyo ? "largeBiyo" : "largeCare";
  }
  if (size === "medium") {
    return isBiyo ? "mediumBiyo" : "mediumCare";
  }
  return "none";
};
